import { FansUnitedSDK } from "fansunited-sdk-esm";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { API_KEY, CLIENT_ID } from "../api/constants";
import { getUserLanguage, getUserToken } from "../redux/user/selectors";

const useFansUnitedSDK = () => {
	const [fansUnitedSDK, setFansUnitedSDK] = useState(null);
	const language = useSelector(getUserLanguage);
	const token = useSelector(getUserToken);

	useEffect(() => {
		const initializeSDK = async () => {
			try {
				// Initialize SDK with or without token
				const sdkConfig = {
					apiKey: API_KEY,
					environment: "prod",
					clientId: CLIENT_ID,
					lang: language,
					idSchema: "native",
					errorHandlingMode: "default",
				};

				// Only add authProvider if we have a token
				if (token) {
					sdkConfig.authProvider = {
						getIdToken: () => token,
						logout: () => console.log("LOGOUT"),
					};
				}

				const sdk = FansUnitedSDK(sdkConfig);
				setFansUnitedSDK(sdk);
			} catch (error) {
				console.error("Error initializing SDK:", error);
				setFansUnitedSDK(null);
			}
		};

		initializeSDK();
	}, [language, token]);

	return fansUnitedSDK;
};

export default useFansUnitedSDK;
